export const crmHomeCubeAccessRoles: readonly string[] = ["crm.admin", "crm.supervisor", "crm.bi-reader"];

export const hasCrmHomeCubeAccess = (roles: readonly string[]) =>
  crmHomeCubeAccessRoles.some((r) => roles.includes(r));

export const isCrmHomeCubeDirectorAnalytics = (roles: readonly string[]): boolean =>
  roles.includes("crm.admin") || roles.includes("crm.supervisor");
